import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';

const CustomApexBarChart = ({ data, title, barWidth, barOrientation, controls }) => {

    const navigate = useNavigate()
console.log("data", data)
    const containerRef = useRef()
    const [containerWidth, setContainerWidth] = useState(0)

    useEffect(() => {
        if (containerRef){
            console.log("containerRef:", containerRef.current.offsetWidth)
            setContainerWidth(containerRef.current.offsetWidth)
        }
    }, [containerRef])
    
    const fullSeries = data.map((serie) => {
        const formattedData = serie["x-axis"].map((x, i) => ({
            x,
            y: serie["y-axis"][i]
        }));

        return {
            name: "serie.seriesName",
            data: formattedData
        };
    });

    const categories = fullSeries[0]?.data.map(d => d.x) || [];

    const dataCount = categories.length;

    // ⭐ Horizontal expansion width
    const dynamicWidth = dataCount * 80;
    const MIN_WIDTH = 800;

    // FINAL WIDTH LOGIC
    const contentWidth = Math.max(MIN_WIDTH, dynamicWidth);
    const finalWidth = contentWidth < containerWidth ? "100%" : contentWidth;

    // ⭐ Fixed height
    const fixedHeight = 350;

    const options = {
        chart: {
            type: "bar",
            height: fixedHeight,
            width: finalWidth, // expand chart width
            zoom: { enabled: false },
            toolbar: {
                show: controls?.show ?? true,
                tools: {
                    download: controls?.download ?? true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: true
                }
            }
        },

        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "45%",
                distributed: true,
                borderRadius: 6,
            }
        },

        dataLabels: {
            enabled: true,
            style: {
                fontSize: "12px",
                fontWeight: "bold",
                colors: ["#000"]
            }
        },

        xaxis: {
            categories,
            labels: { rotate: -45 }
        },

        grid: {
            row: { colors: ["#f3f3f3", "#fff"], opacity: 0.5 }
        },

        legend: {
            show: false
        },

        // colors: [
        //     "#ff0055", "#ff7a00", "#ffcc00",
        //     "#00d96c", "#00b0ff", "#7048ff",
        //     "#d633ff", "#ff33aa", "#ff5f5f",
        //     "#00ffaa"
        // ],

        colors: [
            "#00b0ff", "#7048ff", "#d633ff"
        ],

        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.4,
                gradientToColors: [
                    "#66d1ff", "#b9a4ff", "#f08cff"
                ],
                // gradientToColors: [
                //     "#ff89a5", "#ffb067", "#ffdf70",
                //     "#91ffc8", "#66d1ff", "#b9a4ff",
                //     "#f08cff", "#ff88ce", "#ff9d9d",
                //     "#98ffdb"
                // ],
                opacityFrom: 0.9,
                opacityTo: 0.9,
                stops: [0, 100]
            }
        }
    };

    return (
        <div className='w-full overflow-x-scroll overflow-y-hidden' ref={containerRef}>
            <div className={`min-w-full max-w-[${dynamicWidth}]`}>
                <ReactApexChart
                    options={options}
                    series={fullSeries}
                    type="bar"
                    height={fixedHeight}
                    width={finalWidth}
                    onClick={() => navigate('/recruitment')}
                />
            </div>
        </div>
    );
};

export default CustomApexBarChart;
